function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .gh0 {\n        fill: #6f7b88;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "gh0",
  x: 6.028,
  y: 20.152,
  width: 8.631,
  height: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "gh0",
  d: "M18.222,3.461H3.691c-1.105,0-2,.895-2,2v11.083c0,1.105.895,2,2,2h7.786c-.21-.474-.364-.976-.46-1.5H3.691c-.276,0-.5-.224-.5-.5V5.461c0-.276.224-.5.5-.5h14.531c.276,0,.5.224.5.5v3.772c.522.088,1.026.229,1.5.43v-4.202c0-1.105-.895-2-2-2Z"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  className: "gh0",
  points: "20.684 15.38 17.606 12.302 14.528 15.38 16.871 15.38 16.871 19.371 18.342 19.371 18.342 15.38 20.684 15.38"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "gh0",
  d: "M17.606,10.633c2.869,0,5.203,2.334,5.203,5.203s-2.334,5.203-5.203,5.203-5.203-2.334-5.203-5.203,2.334-5.203,5.203-5.203M17.606,9.133c-3.702,0-6.703,3.001-6.703,6.703s3.001,6.703,6.703,6.703,6.703-3.001,6.703-6.703-3.001-6.703-6.703-6.703h0Z"
});

var SvgSimultaneousBackupSlider = function SvgSimultaneousBackupSlider(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSimultaneousBackupSlider, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/simultaneousBackupSlider.f4f0a745.svg";
export { ForwardRef as ReactComponent };